import type {INWScriptDefAction} from "@/interface/nwscript/INWScriptDefAction";

/**
 * NWScriptDef class.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file NWScriptDef.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export class NWScriptDef {
  static Actions: {[key: number]: INWScriptDefAction} = {};
}
